import React, { useState } from "react";
import ComponentCustomModal from "../../../components/common/customModal/ComponentCustomModal";
import { Form, Formik } from "formik";
import { FtextField } from "../../../components/common/FtextField";
import * as Yup from "yup";
import {
  createNetFeeServer,
  updateNetFeeServer,
} from "../../../features/apiCallAdmin";
import { useDispatch } from "react-redux";

const ServerDialog = ({ show, setShow, isUpdate, server }) => {
  const dispatch = useDispatch();

  const inputOptions = [
    {
      as: "select",
      id: "serverType",
      name: "serverType",
      label: "Server Type",
      firstOptions: "Select Server Type",
      textAccessor: "name",
      valueAccessor: "value",
      options: [
        {
          name: "Basic",
          value: "basic",
        },
        {
          name: "Standard",
          value: "standard",
        },
      ],
      validation: true,
      isVisible: true,
      disabled: false,
    },
    {
      type: "text",
      id: "url",
      name: "url",
      label: "URL",
      placeholder: "https://netfee.top",
      validation: true,
      isVisible: true,
      disabled: false,
    },
  ];

  //---> Local State
  const [isLoading, setIsLoading] = useState(false);

  const initialValues = {
    serverType: server?.serverType ?? "",
    url: server?.url ?? "",
  };

  const validationSchema = Yup.object().shape({
    serverType: Yup.string().required(),
    url: Yup.string().required(),
  });

  const handleFormSubmit = (formValues) => {
    if (isUpdate) {
      updateNetFeeServer(
        dispatch,
        formValues,
        server?._id,
        setIsLoading,
        setShow,
      );
    } else {
      createNetFeeServer(dispatch, formValues, setIsLoading, setShow);
    }
  };

  return (
    <>
      <ComponentCustomModal
        show={show}
        setShow={setShow}
        centered={true}
        header={isUpdate ? "Server update" : "Add new server"}
      >
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          enableReinitialize
          onSubmit={handleFormSubmit}
        >
          {() => (
            <Form id="serverForm">
              <div className="displayGrid mb-3">
                {inputOptions?.map(
                  (item) => item?.isVisible && <FtextField {...item} />,
                )}
              </div>

              <div className="d-flex justify-content-end">
                <button
                  type="submit"
                  className="btn btn-success"
                  disabled={isLoading}
                >
                  Submit
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </ComponentCustomModal>
    </>
  );
};

export default ServerDialog;
